import { Product } from "@/mocks/products";
import { useLocalized } from "@/lib/localize";
import { useBilingual } from "@/lib/bilingual";

interface ProductTabsProps {
  product: Product;
}

// Product description — dimensions, material and workmanship only.
// The former tabs (Specifications / Customization / Shipping & Payment /
// Certifications) were removed per the redesigned product-page template.
const ProductTabs = ({ product }: ProductTabsProps) => {
  const loc = useLocalized();
  const b = useBilingual();

  const rows: [string, string][] = [
    [b("Dimensions", "尺寸"), loc(product.specs.dimensions)],
    [b("Material & Workmanship", "材質與做工"), loc(product.material)],
  ];

  return (
    <div className="mt-14 border-t border-stone-200 pt-10">
      <h3 className="text-stone-900 font-bold text-xl mb-6">
        {b("Product Description", "產品說明")}
      </h3>
      <table className="w-full max-w-2xl text-sm">
        <tbody>
          {rows.map(([label, value], i) => (
            <tr key={label} className={i % 2 === 0 ? "bg-stone-50" : "bg-white"}>
              <td className="px-5 py-3 text-stone-500 font-medium w-1/3 rounded-l-lg align-top">
                {label}
              </td>
              <td className="px-5 py-3 text-stone-800 rounded-r-lg">
                {value || b("To be confirmed", "待確認")}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProductTabs;
